import { DayPicker } from 'react-day-picker';
import { FC } from 'react';
import { ru } from 'date-fns/locale';
import { CalendarWrapper, GlobalStyle } from './styles';
import { CalendarDatePickerProps } from '../types';
import { CalendarTimePickerRange } from '../calendarTimePicker/calendarTimePickerRange';
import { CalendarTimePicker } from '../calendarTimePicker/calendarTimePicker';

export const CalendarDatePicker: FC<CalendarDatePickerProps> = ({
	isOpenCalendar = false,
	selected,
	selectedRange,
	mode = 'single',
	timePicker,
	onSelect,
	onSelectRange,
	onMonthChange,
}) => {
	return (
		<CalendarWrapper role="calendar" $isOpenCalendar={isOpenCalendar}>
			{mode === 'single' ? (
				<DayPicker
					mode="single"
					className="date-picker"
					selected={selected}
					onSelect={onSelect}
					locale={ru}
					month={selected}
					onMonthChange={onMonthChange}
				/>
			) : (
				<DayPicker
					mode="range"
					className="date-picker"
					selected={selectedRange}
					onSelect={onSelectRange}
					locale={ru}
				/>
			)}
			{timePicker && (
				<>
					<GlobalStyle />
					<CalendarTimePickerRange
						timeRange={timePicker.timeRange}
						onTimeChange={timePicker.onTimeChange}
					/>
					<CalendarTimePicker
						timeValue={timePicker.timeValue}
						onTimeChange={timePicker.onTimeChange}
					/>
				</>
			)}
		</CalendarWrapper>
	);
};
